import styled from "@emotion/styled"

const ArticleContentTableCell = styled.td`
    padding: 20px;
    line-height: 24px;
`

export default ArticleContentTableCell
